import { colors } from 'components/styles/variables';

interface LoadingSpinnerProps {
  containerSize: number;
  spinnerSize: number;
  isWhite?: boolean;
}

export default function LoadingSpinner({
  containerSize,
  spinnerSize,
  isWhite,
}: LoadingSpinnerProps): JSX.Element {
  return (
    <div className="lds-ring" data-testid="loading-spinner">
      <div />
      <div />
      <div />
      <div />
      <style jsx>{`
        .lds-ring {
          display: inline-block;
          position: relative;
          width: ${containerSize}px;
          height: ${containerSize}px;
        }
        .lds-ring div {
          box-sizing: border-box;
          display: block;
          position: absolute;
          width: ${spinnerSize}px;
          height: ${spinnerSize}px;
          margin: ${(containerSize - spinnerSize) / 2}px;
          border: 3px solid white;
          border-radius: 50%;
          animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
          border-color: ${isWhite ? colors.WHITE : colors.ALR1} transparent transparent transparent;
        }
        .lds-ring div:nth-child(1) {
          animation-delay: -0.45s;
        }
        .lds-ring div:nth-child(2) {
          animation-delay: -0.3s;
        }
        .lds-ring div:nth-child(3) {
          animation-delay: -0.15s;
        }
        @keyframes lds-ring {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
}
